// @ts-nocheck
import { DatePickerState } from "@insite/mobius/DatePicker";
import { CustomerPoNumber } from "@store/Framework/Services/CustomerPoNumberService";
import { useState } from "react";

const useEditManageDefaultPO = (
    customerPoNumber: CustomerPoNumber,
    onSave: (customerPoNumber: CustomerPoNumber) => void,
    validateEndDate: (startDate: Date, endDate: Date | null) => boolean,
    validateStartDate: (startDate: Date, endDate: Date | null) => boolean,
) => {
    const [poNumber, setPoNumber] = useState(customerPoNumber.poNumber);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [startDate, setStartDate] = useState<Date>(new Date(customerPoNumber.startDate));
    const [endDate, setEndDate] = useState(customerPoNumber.endDate ? new Date(customerPoNumber.endDate) : undefined);
    const isValidSubmit =
        !!poNumber && validateStartDate(startDate, endDate || null) && validateEndDate(startDate, endDate || null);
    const handleSave = () => {
        onSave({
            ...customerPoNumber,
            poNumber,
            startDate,
            endDate: endDate || null,
        });
        setHasSubmitted(false);
    };
    const handleSubmit = () => {
        if (isValidSubmit) {
            handleSave();
            return;
        }
        if (!hasSubmitted) {
            setHasSubmitted(true);
        }
    };
    const handleStartDateChange = ({ selectedDay }: DatePickerState) => {
        if (selectedDay) {
            setStartDate(selectedDay);
        }
    };
    const handleEndDateChange = ({ selectedDay }: DatePickerState) => {
        setEndDate(selectedDay);
    };

    return {
        poNumber,
        setPoNumber,
        startDate,
        endDate,
        handleStartDateChange,
        handleEndDateChange,
        handleSubmit,
        isValidSubmit,
        hasSubmitted,
    };
};

export default useEditManageDefaultPO;
